export default "__VITE_ASSET__39aa426c__"